<template>
  <!--渲染表单-->
  <el-form ref="form" :class="[readerMode ? 'process-form process-form-show' : 'process-form']"
    :label-position="readerMode ? 'left' : 'top'" :rules="rules" :model="_value">
    <!-- rules:{{ rules }} -->
    <template v-for="(item, index) in forms">
      <!-- E 可编辑 R 只读 H 隐藏 -->
      <template v-if="item.perm !== 'H'">
        <el-form-item :key="item.name + index" v-if="item.name !== 'SpanLayout' && item.name !== 'Description'"
          :prop="item.id" :label="readerMode ? item.title + '：' : item.title" :class="setFormItemClass(item)">
          <form-design-render :ref="`sub-item_${item.id}`" v-model="_value[item.id]" mode="PC" :config="item" :userInfo="userInfo"
            @delInput="delInput" :readerMode="readerMode" />
        </el-form-item>
        <template v-else>
          <form-design-render :key="index" ref="span-layout" v-model="_value" mode="PC" :config="item"
            :readerMode="readerMode" />
        </template>
      </template>
    </template>
  </el-form>
</template>

<script>
import FormDesignRender from '@/pages/officeApproval/common/layout/FormDesignRender'
import { FormItem } from 'element-ui';

export default {
  name: "FormRender",
  components: { FormDesignRender },
  props: {
    forms: {
      type: Array,
      default: () => {
        return []
      }
    },
    value: {
      type: Object,
      default: () => {
        return {}
      }
    },
    readerMode: {
      type: Boolean,
      default: false,
    },
    userInfo: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      rules: {},
    }
  },
  created() {
    this.loadFormConfig(this.forms)
  },
  computed: {
    _value: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    setFormItemClass(item) {
      let iconName = String(item.icon).split('-')[1]
      if (iconName == 'shengshiqu') { // 省市区
        // console.log('>>',item.props.inputType)
        iconName += '-' + item.props.inputType
      } else if (iconName == 'jine') { // 金额
        // console.log('>>',item)
        iconName += '-' + (item.props.showChinese ? 'has' : 'none')

      }
      let defaultClass = 'el-form-item-' + iconName
      // 针对表格组件增加专属类名，便于审批详情样式定制
      // const tableListClass = item.name === 'TableList' ? ' el-form-item-biaoge' : ''
      let tableListClass = ''
      if (item.name === 'TableList' || item.name === 'OfficeSuppliesTable' || item.name === 'PurchaseGoodsList') {
        tableListClass = ' el-form-item-biaoge'
      }
      // 只在审批中设置
      if (this.$route.name == 'approvalManageDetail' && item.perm === 'E') {
        return 'el-form-item-edit ' + defaultClass + tableListClass
      } else {
        return defaultClass + tableListClass
      }
    },
    validate(call) {
      const uploading=component=>component.pendingApprovalUploads>0||(component.$children||[]).some(uploading);
      if(uploading(this)){this.$message.warning('附件正在上传，请上传完成后再提交');call(false);return;}
      let success = true
      this.$refs.form.validate(valid => {
        // console.log('>>',valid)
        success = valid
        if (valid) {
          //校验成功再校验内部
          for (let i = 0; i < this.forms.length; i++) {
            const formItem = this.forms[i]
            if (formItem.name === 'TableList' || formItem.name === 'PurchaseGoodsList') {
              let formRef = this.$refs[`sub-item_${formItem.id}`]
              if (formRef && Array.isArray(formRef) && formRef.length > 0) {
                formRef[0].validate(subValid => {
                  success = subValid
                })
                if (!success) {
                  break
                }
              }
            }
          }
        }
        call(success)
      });
    },
    // 提示信息
    getRequiredMessage(item) {
      let action = '请填写'
      const selectTypes = ['SelectInput', 'MultipleSelect', 'DateTime', 'DateTimeRange', 'DeptPicker', 'UserPicker']
      const uploadTypes = ['FileUpload', 'ImageUpload']

      if (uploadTypes.includes(item.name)) {
        action = '请上传'
      } else if (selectTypes.includes(item.name)) {
        action = '请选择'
      } else if (item.name === 'AreaPicker' && (item.props.inputType === 'city' || item.props.inputType === 'area')) {
        action = '请选择'
      }

      return action + item.title
    },
    loadFormConfig(forms) {
      forms.forEach(item => {
        if (item.name === 'SpanLayout') {
          this.loadFormConfig(item.props.items)
        } else {
          // // 固定办公物资表的字段键，避免随机 id
          // if (item.name === 'OfficeSuppliesTable') {
          //   this.$set(item, 'id', 'PurchaseGoodsList')
          // }
          this.$set(this._value, item.id, this.value[item.id])
          if (item.props.required) {
            // console.log('==>>',item)
            // 提示信息
            const message = this.getRequiredMessage(item)
            this.$set(this.rules, item.id, [{
              type: item.valueType === 'Array' ? 'array' :
                (item.valueType === 'Object' ? 'object' :
                  (item.valueType === 'Number' ? 'number' : undefined)),
              required: true,
              message: message, trigger: ['blur', 'change']
            }])
          }
        }
      })
    },
    delInput(fileId) {
      this._value[fileId] = undefined
      // console.log('>>',e,this._value)

    }
  }
}
</script>

<style lang="scss" scoped>
// 发起审批
.process-form {
  /deep/ {
    .el-form-item-tupian {

      // 图片组件带了4px
      .el-form-item__error {
        padding-top: 0;
      }
    }

    .el-form-item__label {
      padding: 0 0;

    }

    .el-form-item__content {
      line-height: 1;
      //  background-color: rgba($color: #0000ff, $alpha: .1);
      //  outline: 1px dotted red;
    }

    .el-input--small {
      .el-input__inner {
        line-height: 1;
        padding-left: 8px;
      }

      .el-textarea__inner {
        padding-left: 8px;
      }
    }

    .office-supplies-table {
      .last-column {
        .custom-date-picker {
          .el-input__prefix {
            left: auto;
            right: 5px;
          }

          .el-input__inner {
            padding-left: 8px;
            padding-right: 30px;
          }
        }
      }
    }
  }
}

// 审批中
.process-form-show {
  padding-bottom: 50px;

  // E 可编辑 R 只读 H 隐藏
  .box-e {
    float: left;
    flex: 1;
    line-height: 44px;
  }

  /deep/ {
    .el-form-item__content {
      line-height: 44px;
      // background-color: rgba($color: #0000ff, $alpha: .1);
      min-height: 44px;
    }

    .el-form-item__error {
      padding-top: 2px;
    }

    .el-form-item-danhang,
    .el-form-item-danxuan,
    .el-form-item-duoxuan,
    .el-form-item-riqi,
    .el-form-item-riqiqujian,
    .el-form-item-dianhua,
    .el-form-item-fujian,
    .el-form-item-bumen,
    .el-form-item-shengshiqu-city,
    .el-form-item-shengshiqu-area,
    .el-form-item-shuzi,
    .el-form-item-jine-none {

      // 单选组件，错误信息提示间距
      .el-form-item__error {
        padding-top: 0;
        margin-top: -3px;
      }
    }

    .el-input--small {
      .el-input__inner {
        line-height: 1;
        padding-left: 8px;
      }

      .el-textarea__inner {
        padding-left: 8px;
      }

      .el-input__icon {
        height: 32px;
      }
    }

    .el-form-item {
      margin-bottom: 0;
    }

    .el-form-item__label {
      color: #939696;
      line-height: 44px;
    }

    .el-form-item-edit {
      padding: 6px 0;

      .el-form-item__label {
        color: #2F3030
      }
    }

    // .el-form-item-edit.el-form-item-tupian{
    //   padding: 4px 0;
    // }
    .form-item-text {
      padding-top: 11px;
      line-height: 21px;
      color: #2F3030;
      word-break: break-word;

      a {
        color: #2F3030;
        text-decoration: none;

        &:hover {
          text-decoration: underline;
        }
      }
    }

    .el-form-item__content {
      display: flex;
    }

    // 审批详情页：表格组件换行展示，不受 flex 影响
    .el-form-item-biaoge {
      .el-form-item__content {
        display: block;
        .el-table__footer-wrapper {
        td {
          background-color: #FFFBDB;
          font-weight: bold;
          color: #606266;
        }
        tbody td.el-table__cell {
          background-color: #FFFBDB;
        }
      }
      } 
    }

  }
}
</style>
